module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"en":{"meta":{"title":"Password Reset","description":"Forgot your password? You can reset it here."},"title":"Password reset","email":"Email","reset":"Reset password","sending":"Sending password reset email...","success":"Perfect! Please check your email inbox for instructions!","alreadySent":"We have already sent a password reset email"}}')
  delete Component.options._Ctor
}
